import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './app/environment/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'info', 'warn', 'error'] }),
    ],
    enableLogs: true,
    tracesSampleRate: environment.sentryTracesSampleRate,
    replaysSessionSampleRate: environment.sentryReplaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentryReplaysOnErrorSampleRate,
    sendDefaultPii: true,
    ignoreErrors: [
      'ChunkLoadError',
      'Loading chunk',
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
      'Navigation ID',
      'ExpressionChangedAfterItHasBeenCheckedError',
    ],
  });

  Sentry.logger.info('Frontend bootstrap', {
    log_source: 'sentry_test',
    environment: environment.production ? 'production' : 'development',
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
